﻿import '../components/job-salary.js';

(function handleFileComponents() {
    const submitBtn = document.getElementById("submitBtn");

    const fileUploadComponents = document.querySelectorAll('hh-file-upload');

    [].forEach.call(fileUploadComponents, (element) => {
        element.addEventListener('fileRemoved', event => {
            const inputName = event.detail.inputName;

            const fileNodes = document.querySelectorAll(`[id^='${inputName}']`);

            Array.from(fileNodes).forEach(fileInput => {
                fileInput.value = null;
            });
        });

        element.addEventListener('fileUploaded', event => {
            const details = event.detail;

            // loop over keys in repsonse to set hidden inputs
            for (var key in details.response) {
                const value = details.response[key];
                const property = key[0].toUpperCase() + key.slice(1);
                let hiddenInput = document.getElementById(`${details.inputName}_${property}`);

                hiddenInput.value = value;
            }
            submitBtn.disabled = false;
        });
        // prevent default so we can get drop event
        element.addEventListener("dragover", function (event) {
            event.preventDefault();
        });

        element.addEventListener("disableForm", event => {
            submitBtn.disabled = event.detail.disable;
        })
    });
}());

function clickHandler(event) {

    var invalidFields = form.querySelectorAll(
        ':invalid:not(fieldset):not([type="radio"]):not([type="checkbox"])'
    );

    var errorMessages = form.querySelectorAll(".form-error-txt"),
        radioGroups = form.querySelectorAll(".radio-required"),
        checkboxGroups = form.querySelectorAll(".checkbox-required"),
        fileInputs = form.querySelectorAll("file-upload");

    // Remove any existing messages
    for (var i = 0; i < errorMessages.length; i++) {
        errorMessages[i].parentNode.removeChild(errorMessages[i]);
    }

    for (var r = 0; r < radioGroups.length; r++) {

        var invalidRadioFields = radioGroups[r].querySelectorAll(":invalid");

        if (invalidRadioFields && invalidRadioFields.length) {
            var invalidMessage =
                invalidRadioFields[0].validationMessage || "Please select one of these options.";
            radioGroups[r].insertAdjacentHTML(
                "beforeend",
                "<div class='form-error-txt'>" + invalidMessage + "</div>"
            );
        }
    }

    for (var i = 0; i < checkboxGroups.length; i++) {
        var boxes = checkboxGroups[i].querySelectorAll("input");
        [].forEach.call(boxes, function (box) {
            box.setAttribute("required", "required");
        });

        var selectedValues = checkboxGroups[i].querySelectorAll(":checked");

        var invalidCheckboxFields = checkboxGroups[i].querySelectorAll("input:not(:checked)");

        if (selectedValues.length) {
            [].forEach.call(invalidCheckboxFields, function (box) {
                box.removeAttribute("required", "required");
            });
        }

        if (invalidCheckboxFields.length && !selectedValues.length) {
            var invalidMessage =
                invalidCheckboxFields[0].validationMessage || "Please select one of these options.";
            checkboxGroups[i].insertAdjacentHTML(
                "beforeend",
                "<div class='form-error-txt'>" + invalidMessage + "</div>"
            );
        }
    }

    for (var i = 0; i < fileInputs.length; i++) {
        var fileComponent = fileInputs[i];

        var input = fileComponent.shadowRoot.querySelector("input")
        // check if input is valid and if theres no file after been dropped into the component
        if (!input.checkValidity() && !fileComponent.$$.ctx[2]) {
            fileComponent.setAttribute("requirederror", true);
        }
    }

    for (var i = 0; i < invalidFields.length; i++) {
        var parentNode =
            invalidFields[i].type == "file"
                ? invalidFields[i].parentNode.parentNode
                : invalidFields[i].parentNode;
        var invalidMessage = invalidFields[i].validationMessage || "Please fill out this field.";
        parentNode.insertAdjacentHTML(
            "beforeend",
            "<div class='form-error-txt'>" + invalidMessage + "</div>"
        );
    }

    // If there are errors, give focus to the first invalid field
    if (invalidFields.length > 0) {
        for (var i = 0; i < invalidFields.length; i++) {
            if (invalidFields[i].type != "fieldset") {
                invalidFields[i].focus();
                return;
            }
        }
    }
}

function submitHandler(e) {

    var isFormValid = form.checkValidity();

    if (!isFormValid) {
        e = e || event;
        e.preventDefault ? e.preventDefault() : (e.returnValue = false);
        form.classList.add('submitted');
    } else {
        form.classList.remove('submitted');
        formSubmitting = true;
        var submitBtn = document.getElementById("submitBtn");

        submitBtn.disabled = true;
        submitBtn.classList.add('loading');
    }
}

function removeImage() {
    var imageContainer = document.getElementById("image-container");
    var msgImage = document.getElementById("msg-img");

    msgImage.parentElement.removeChild(msgImage);
    imageContainer.parentNode.removeChild(imageContainer);
}

function replaceValidationUI() {

    // Suppress the default bubbles
    function invalidHandler(event) {
        event.preventDefault();
    }

    form.addEventListener("invalid", invalidHandler);

    // Support Safari, iOS Safari, and the Android browser—each of which do not prevent
    // form submissions by default

    form.addEventListener("submit", submitHandler);

    function changeHandler(event) {
        isDirty = true;

        if (!event.target)
            return;

        var inputType = event.target.type;

        if (inputType === "radio" || inputType === "checkbox") {
            var groupSelector = "." + inputType + "-required";
            var requiredGroup = event.target.closest(groupSelector);

            if (!requiredGroup)
                return;

            var inputs = requiredGroup.querySelectorAll("input");

            var isValid = false;

            [].forEach.call(inputs, function (input) {
                if (input.checked)
                    isValid = true;
            });

            var errorElement = requiredGroup.querySelector(".form-error-txt");

            if (!errorElement)
                return;

            if (isValid) {
                errorElement.classList.add("hidden");

                if (inputType === "checkbox") {
                    var otherBoxes = requiredGroup.querySelectorAll(":invalid");

                    [].forEach.call(otherBoxes, function (box) {
                        box.removeAttribute("required", "required");
                    });
                }
            }
            else {
                errorElement.classList.remove("hidden");

                if (inputType === "checkbox") {
                    var otherBoxes = requiredGroup.querySelectorAll("input");

                    [].forEach.call(otherBoxes, function (box) {
                        box.setAttribute("required", "required");
                    });
                }
            }
        }
    }
    form.addEventListener("change", changeHandler);

    var submitButton = form.querySelector("button[type=submit]");

    submitButton.addEventListener("click", clickHandler);

    var deleteImageButton = document.getElementById("delete-image");
    if (deleteImageButton) deleteImageButton.addEventListener("click", removeImage);
}

// Replace the validation UI for all forms
var forms = document.querySelectorAll("form");

var form = forms[0];
replaceValidationUI();

var formSubmitting = false;
var isDirty = false;
var setFormSubmitting = function () {
    formSubmitting = true;
};

var isFormDirty = function () {
    // Gets a required form fields that are valid
    // This means the form has some values entered and is considered dirty
    return document.querySelectorAll('form[name="ApplicationForm"] :required:valid:not(fieldset):not(select)').length > 0;
}

const resetFormIfNeeded = event => {
    if (window.__modelStateCount && window.__modelStateCount < 3) {        
        const applicationForm = document.querySelector('form[name="ApplicationForm"]');
        applicationForm.reset();
    }
};

window.addEventListener("pageshow", resetFormIfNeeded);

window.onload = function () {
    if (window.addEventListener) {
        window.addEventListener("beforeunload", function (e) {
            var confirmationMessage = "Your application has not been completed. ";
            confirmationMessage += "If you leave before applying, your application will be lost.";

            if (formSubmitting || !isFormDirty()) {
                return undefined;
            }

            (e || window.event).returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
        });
    }
};

if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (fun /*, thisArg */) {
        "use strict";
        if (this === void 0 || this === null || typeof fun !== "function") throw new TypeError();

        var t = Object(this),
            len = t.length >>> 0,
            thisArg = arguments.length >= 2 ? arguments[1] : void 0;

        for (var i = 0; i < len; i++) if (i in t) fun.call(thisArg, t[i], i, t);
    };
}

if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        "use strict";
        if (typeof start !== "number") {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
